import moment from "moment";

export function useDate() {
  function dateToClient(strDate) {
    // ✅ VALIDAÇÃO: Verificar se a data é válida e não está vazia/null/undefined
    if (!strDate || strDate === null || strDate === undefined || strDate === '') {
      return '-';
    }
    
    // ✅ Tentar converter para Date se for string ISO
    let dateToFormat = strDate;
    if (typeof strDate === 'string') {
      // Se for string ISO, moment deve conseguir processar
      dateToFormat = strDate;
    } else if (strDate instanceof Date) {
      // Se for Date, converter para ISO string
      dateToFormat = strDate.toISOString();
    }
    
    // ✅ Tentar moment primeiro
    const momentDate = moment(dateToFormat);
    if (momentDate.isValid()) {
      return momentDate.format("DD/MM/YYYY");
    }
    
    // ✅ Se moment não conseguir, tentar new Date
    try {
      const jsDate = new Date(dateToFormat);
      if (!isNaN(jsDate.getTime()) && jsDate.getTime() > 0) {
        return moment(jsDate).format("DD/MM/YYYY");
      }
    } catch (e) {
      // Silencioso - não logar para evitar spam no console
    }
    
    return '-';
  }

  function datetimeToClient(strDate) {
    // ✅ VALIDAÇÃO: Verificar se a data é válida e não está vazia/null/undefined
    if (!strDate || strDate === null || strDate === undefined || strDate === '') {
      return '-';
    }
    
    // ✅ Tentar converter para Date se for string ISO
    let dateToFormat = strDate;
    if (typeof strDate === 'string') {
      // Se for string ISO, moment deve conseguir processar
      dateToFormat = strDate;
    } else if (strDate instanceof Date) {
      // Se for Date, converter para ISO string
      dateToFormat = strDate.toISOString();
    }
    
    // ✅ Tentar moment primeiro
    const momentDate = moment(dateToFormat);
    if (momentDate.isValid()) {
      return momentDate.format("DD/MM/YYYY HH:mm");
    }
    
    // ✅ Se moment não conseguir, tentar new Date
    try {
      const jsDate = new Date(dateToFormat);
      if (!isNaN(jsDate.getTime()) && jsDate.getTime() > 0) {
        return moment(jsDate).format("DD/MM/YYYY HH:mm");
      }
    } catch (e) {
      // Silencioso - não logar para evitar spam no console
    }
    
    return '-';
  }

  function dateToDatabase(strDate) {
    if (moment(strDate, "DD/MM/YYYY").isValid()) {
      return moment(strDate).format("YYYY-MM-DD HH:mm:ss");
    }
    return strDate;
  }

  function returnDays(date) {
    let data1 = new Date()
    let data2 = new Date(date)
    let result = data2.getTime() - data1.getTime();
    let days = Math.ceil(result / (1000 * 60 * 60 * 24));

    if (days === -0) {
      days = 0
    }
    return days;
  }

  return {
    dateToClient,
    datetimeToClient,
    dateToDatabase,
    returnDays
  };
}
